import React from "react";

import { themeColor } from "src/styles";

import { Box, Image, Link, Text } from "src/components/base";

const Container = ({ link, linkDescription, ...props }) => {
  if (link) {
    return (
      <Link to={link} title={linkDescription} {...props}>
        {props.children}
      </Link>
    );
  }

  return <Box {...props} />;
};

export default ({
  captionStyle,
  parentTheme,
  imageProps,
  content: {
    id,
    altText,
    image,
    caption,
    subCaption,
    theme,
    link,
    linkDescription,
  },
  ...props
}) => {
  const currentTheme = theme || parentTheme;
  const currentThemeColor = themeColor(currentTheme);
  const currentThemeColorTransparent = themeColor(currentTheme, true);

  return image ? (
    <Box {...props} position="relative">
      <Container link={link} linkDescription={linkDescription}>
        <Image
          height={[300, 300, 500]}
          sizes={image.sizes}
          alt={altText || caption}
          fadeIn={true}
          {...imageProps}
        />

        {Boolean(caption) ? (
          <Box
            bg={currentThemeColorTransparent}
            captionTheme={theme}
            px={[2, 2, 4]}
            py={[2, 2, 3]}
            position="absolute"
            style={{
              left: 0,
              bottom: 0,
              right: 0,
            }}
          >
            <Text
              color="white"
              fontWeight="semibold"
              fontSize={[3, 4, 5]}
              style={{
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {caption}
            </Text>
            {subCaption && (
              <Text
                color="white"
                fontWeight="light"
                fontSize={[1, 2, 3]}
                mt={1}
                style={{
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {subCaption}
              </Text>
            )}
          </Box>
        ) : (
          <Box
            height={15}
            bg={currentThemeColor}
            position="absolute"
            style={{
              left: 0,
              bottom: 0,
              right: 0,
            }}
          />
        )}
      </Container>
    </Box>
  ) : null;
};

export const photoWithCaptionFragment = graphql`
  fragment PhotoWithCaptionContents on ContentfulPhotoWithCaption {
    id
    altText
    caption
    subCaption
    theme
    image {
      sizes(maxWidth: 2000, maxHeight: 1000, quality: 80) {
        ...GatsbyContentfulSizes_withWebp
      }
    }
    link
    linkDescription
  }
`;



// WEBPACK FOOTER //
// ./src/components/PhotoWithCaption/PhotoWithCaption.js